<div *ngIf="entities != null">
    <div style="font-weight: bold">Matching Pronunciation Entries:</div>

    <span *ngFor="let obj of entities; let isLast=last">
        <span>{{obj.Text}} ({{obj.PronunciationHtml}})</span>{{isLast ? '' : ', '}}
    </span>
</div>